import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Calculo from "./pages/Calculo";
import Vendedores from "./pages/Vendedores";
import Parametros from "./pages/Parametros";
import Historico from "./pages/Historico";
import Relatorios from "./pages/Relatorios";
import Usuarios from "./pages/Usuarios";
import Navbar from "./components/Navbar";
import { BASE_PATH } from "./basePath";

function ProtectedRoute({ children, adminOnly = false }) {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  if (!token) return <Navigate to="/login" />;
  if (adminOnly && role !== "admin") return <Navigate to="/calculo" />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter basename={BASE_PATH}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <>
                <Navbar />
                <div className="container-fluid py-4">
                  <Routes>
                    <Route path="/calculo" element={<Calculo />} />
                    <Route path="/historico" element={<Historico />} />
                    <Route
                      path="/dashboard"
                      element={<ProtectedRoute adminOnly><Dashboard /></ProtectedRoute>}
                    />
                    <Route
                      path="/vendedores"
                      element={<ProtectedRoute adminOnly><Vendedores /></ProtectedRoute>}
                    />
                    <Route
                      path="/parametros"
                      element={<ProtectedRoute adminOnly><Parametros /></ProtectedRoute>}
                    />
                    <Route
                      path="/relatorios"
                      element={<ProtectedRoute adminOnly><Relatorios /></ProtectedRoute>}
                    />
                    <Route
                      path="/usuarios"
                      element={<ProtectedRoute adminOnly><Usuarios /></ProtectedRoute>}
                    />
                    <Route path="*" element={<Navigate to="/calculo" />} />
                  </Routes>
                </div>
              </>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
